import React from 'react';
import css from '@/components/pages/assessments/assessments.module.scss';
import { colsByLayout } from '../util';

export const displayContext = React.createContext({});

export const DisplayProvider = ({ display, layout, children }) => {
  display = display || {};
  const classNames = display.css || {};
  const cols = Object.assign({}, colsByLayout(layout), display.cols || {});

  const getClassStr = (key, otherClasses) => {
    let c = '';
    const keys = Array.isArray(key) ? key : key.split(' ');
    keys.forEach((k) => {
      const v = classNames[k] || k;
      c += v + ' ' + (css[v] || '') + ' ';
    });
    return [c, otherClasses || ''].join(' ').trim();
  };

  const propertyForKey = (key) => {
    const parts = key.split('.');
    let val = display;
    for (let i = 0; i < parts.length; i++) {
      if (typeof val[parts[i]] === 'undefined') {
        return undefined;
      }
      val = val[parts[i]];
    }
    return val;
  };

  const attrs = (key) => ({
    className: getClassStr(key),
    'data-cy': key
  });

  return <displayContext.Provider value={{ css: getClassStr, display: propertyForKey, layout, cols, attrs }}>{children}</displayContext.Provider>;
};

export const DisplayConsumer = displayContext.Consumer;
